// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"DashBoard_Dashboard__DY_q7"};